import { router } from 'expo-router'
import { View } from 'react-native'
import { useUnistyles } from 'react-native-unistyles'

import Alert from '@/components/shared/Alert'
import SaveStatus from '@/components/shared/SaveStatus'
import UniIconButton from '@/components/unistyles/UniIconButton'
import OrganizationService from '@/services/organizationService'
import trpc from '@/utils/trpc'

const OrganizationHeaderRight = () => {
  const { theme } = useUnistyles()
  const isSaving = OrganizationService.useIsSaving()
  const { organizationQueryData, refreshOrganization } =
    OrganizationService.useCurrentOrganization()
  const deleteOrganizationMutation = trpc.organization.delete.useMutation()

  if (!organizationQueryData) {
    return null
  }

  const handleDeleteOrganization = () => {
    Alert.alert(
      'Delete Organization',
      'Are you sure you want to delete this organization? This action is permanent and irreversible. All data associated with this organization will be permanently deleted.',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Delete',
          style: 'destructive',
          onPress: () => {
            deleteOrganizationMutation.mutate(
              {
                organizationId: organizationQueryData?.id,
              },
              {
                onSuccess: () => {
                  refreshOrganization().then(() => {
                    router.dismissTo('/')
                  })
                },
              }
            )
          },
        },
      ]
    )
  }

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <UniIconButton
        icon="delete"
        iconColor={theme.colors.error}
        mode="contained"
        onPress={handleDeleteOrganization}
        testID="delete-organization-button"
      />
      <SaveStatus
        isSaving={isSaving}
        updatedAt={organizationQueryData?.updatedAt}
        // updatedBy={`${foster?.updatedBy.firstName} ${foster?.updatedBy.lastName}`}
      />
    </View>
  )
}

export default OrganizationHeaderRight
